var map = {
	"./animal.svg": 480,
	"./arrow.svg": 481,
	"./bicycle.svg": 482,
	"./boat.svg": 483,
	"./bus.svg": 484,
	"./car.svg": 485,
	"./crane.svg": 486,
	"./default.svg": 487,
	"./helicopter.svg": 488,
	"./motorcycle.svg": 489,
	"./offroad.svg": 490,
	"./person.svg": 491,
	"./pickup.svg": 492,
	"./plane.svg": 493,
	"./ship.svg": 494,
	"./tractor.svg": 495,
	"./train.svg": 496,
	"./tram.svg": 497,
	"./trolleybus.svg": 498,
	"./truck.svg": 499,
	"./van.svg": 500
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 609;